import { render, staticRenderFns } from "./rectifyInfoDialog.vue?vue&type=template&id=6d0a2d02&scoped=true&"
import script from "./rectifyInfoDialog.vue?vue&type=script&lang=ts&"
export * from "./rectifyInfoDialog.vue?vue&type=script&lang=ts&"
import style0 from "./rectifyInfoDialog.vue?vue&type=style&index=0&id=6d0a2d02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0a2d02",
  null
  
)

export default component.exports